
import Input from '../../shared/input';
import { InputProperty, InputEventType } from '../../shared/input/enums';
import TextInputProps from './mixins/TextInputProps';
import { TextInputProperty } from './enums';
import { ControlEventType } from '../../enums';

export default {
  name: 'TextInput',
  components: {
    Input,
  },
  mixins: [TextInputProps],
  data() {
    return {
      InputProperty,
      InputEventType,
      TextInputProperty,
    };
  },
  methods: {
    getIsTextValid(value) {
      if (!value) {
        return true;
      }

      const trimmedValue = value.trim();

      return !!trimmedValue;
    },
    handleInput(event) {
      const isTextValid = this.getIsTextValid(event.target.value);

      if (!isTextValid) {
        // eslint-disable-next-line
        event.target.value = this[TextInputProperty.Value];

        return;
      }

      this.$emit(ControlEventType.Change, event.target.value);
    },
    handleInputFocus(event) {
      this.$emit(ControlEventType.Focus, event.target.value);
    },
    handleInputBlur(event) {
      this.$emit(ControlEventType.Blur, event.target.value);
    },
  },
};
